<template>
    <div>
        <a-breadcrumb>
            <a-breadcrumb-item :style="{ color: '#000' }">
                <a-icon type="appstore" />
                心理云平台
            </a-breadcrumb-item>
            <a-breadcrumb-item v-for="item in breadcrumb" :key="item">{{ item }}</a-breadcrumb-item>
        </a-breadcrumb>
    </div>
</template>
<script>
export default {
    name: 'Index',
    mounted() {
        this.$store.commit('setBreadcrumb', ['工作台'])
    },
    computed: {
        breadcrumb() {
            return JSON.parse(this.$store.state.Breadcrumb.paths)
        }
    }
}
</script>
